import React, { useState } from 'react'
import { Seo } from '../components/Seo'

interface FAQItem {
  question: string
  answer: string
}

const FAQPage: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const faqs: FAQItem[] = [
    {
      question: '로또 번호 생성 서비스는 어떻게 작동하나요?',
      answer: '우리의 알고리즘은 과거 로또 데이터를 분석하여 통계적으로 최적화된 번호 조합을 생성합니다. 다양한 전략과 패턴 분석을 통해 당첨 확률을 높이는데 도움을 드립니다.'
    },
    {
      question: '구독을 취소할 수 있나요?',
      answer: '언제든지 구독을 취소할 수 있습니다. 마이페이지에서 구독 관리 메뉴를 통해 간편하게 취소 가능하며, 취소 후에도 현재 결제 기간 동안은 서비스를 이용할 수 있습니다.'
    },
    {
      question: '생성된 번호로 당첨되면 어떻게 되나요?',
      answer: '생성된 번호는 참고용으로 제공되며, 당첨에 대한 보장은 없습니다. 당첨 여부는 순전히 우연에 의한 것이며, 당사는 당첨에 대한 책임을 지지 않습니다.'
    },
    {
      question: '개인정보는 안전하게 보호되나요?',
      answer: '고객의 개인정보 보호를 위해 최신 보안 기술을 적용하고 있으며, 관련 법령에 따라 안전하게 관리됩니다. 개인정보는 서비스 제공 목적으로만 사용됩니다.'
    },
    {
      question: '결제는 어떤 방법으로 가능한가요?',
      answer: '신용카드, 체크카드, 계좌이체, 무통장입금 등 다양한 결제 방법을 지원합니다. 모든 결제는 SSL 암호화로 안전하게 처리됩니다.'
    }
  ]

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <Seo
        title="자주 묻는 질문(FAQ)"
        description="로또 번호 생성 서비스 이용 방법, 구독/결제/개인정보 등 자주 묻는 질문을 확인하세요."
        canonicalPath="/faq"
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">자주 묻는 질문</h1>
          <p className="text-xl text-gray-600">
            궁금한 점이 있으시면 아래 FAQ를 확인해보세요
          </p>
        </div>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-lg shadow">
              <button
                className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 focus:outline-none focus:bg-gray-50"
                onClick={() => toggleFAQ(index)}
              >
                <span className="text-lg font-medium text-gray-900">{faq.question}</span>
                <svg
                  className={`w-5 h-5 text-gray-500 transform transition-transform ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default FAQPage